import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import LeadFormCRM from '../../../../components/LeadForm/LeadFormCRM';
import ApoelezzLeadForm from '../../../../components/LeadForm/ApoelezzLeadForm';

function TigerAnandaApoelezz({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isOutsideUAE = userInfo?.countryName !== 'United Arab Emirates';

    const images = [
        "/assets/images/projects/tiger-ananda/1.webp",
        "/assets/images/projects/tiger-ananda/2.webp",
        "/assets/images/projects/tiger-ananda/3.webp",
        "/assets/images/projects/tiger-ananda/4.webp"
    ];

    const poster = "/assets/images/projects/tiger-ananda/1.webp";
    const webm = "/assets/images/projects/tiger-ananda/hero.webm";
    const mp4 = "/assets/images/projects/tiger-ananda/hero.mp4";

    return (
        <>
            <div>
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/c6ap/tiger/ananda"
                        : "/c6ap/tiger/ananda/ar"
                    }
                />

                <Height15 />
                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar" ? (
                        <h1 className="text-center px-2 my-1 text-xl">
                            {isOutsideUAE ? (
                                <>
                                    تملك بأسعار زمان بقلب دبي
                                    <br />
                                    فقط <span className="text-2xl bounce-text secondary-text">
                                        123
                                    </span> الف دولار فقط
                                    <br />
                                    عرض حصري لمدة <span className="text-2xl bounce-text secondary-text">
                                        3
                                    </span> أيام فقط
                                    <br />
                                    هتستلم الشقة مفروشة بالكامل
                                </>
                            ) : (
                                <>
                                    {/* <span className="text-2xl bounce-text secondary-text">

                                </span> */}
                                    تملك بأسعار زمان بقلب دبي
                                    <br />
                                    فقط <span className="text-2xl bounce-text secondary-text">
                                        450
                                    </span> الف درهم فقط
                                    <br />
                                    عرض حصري لمدة <span className="text-2xl bounce-text secondary-text">
                                        3
                                    </span> أيام فقط
                                    <br />
                                    هتستلم الشقة مفروشة بالكامل
                                </>
                            )}
                        </h1>
                    ) : (
                        <>
                            <h1 className="text-center px-2 my-1 text-xl">
                                {isOutsideUAE ? (
                                    <>
                                        Own at old prices in the heart of Dubai
                                        <br />
                                        At only <span className="text-2xl bounce-text secondary-text">USD 123K</span>
                                        <br />
                                        Exclusive offer for only <span className="text-2xl bounce-text secondary-text">3</span> days
                                        <br />
                                        Receive the apartment fully furnished!
                                    </>
                                ) : (
                                    <>
                                        Own at old prices in the heart of Dubai
                                        <br />
                                        At only <span className="text-2xl bounce-text secondary-text">AED 450K</span>
                                        <br />
                                        Exclusive offer for only <span className="text-2xl bounce-text secondary-text">3</span> days
                                        <br />
                                        Receive the apartment fully furnished
                                    </>
                                )}
                            </h1>
                        </>
                    )
                    }
                </div>
            </div >
            {/* IMAGES */}
            <div className="flex w-full justify-center mb-5 pb-5">
                <video
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    preload="auto"
                    poster={poster}
                    width="350"
                    height="350"
                    className={`max-w-[350px] rounded-3xl`}
                >
                    <source src={webm} type="video/webm" />
                    <source src={mp4} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            {/* < ImageSlider images={images} /> */}
            <div className="padding-container my-5 py-5">
                {language === "ar"
                    ? (
                        <p className="px-2 my-1">
                            اكتشف تحفة من الفخامة العصرية في قلب موتور سيتي. تقدم هذه الأبراج التوأم شققًا مصممة بأناقة مع إطلالات خلابة، ومرافق عالمية المستوى، وخطة دفع مرنة. تمتع بتجربة معيشية راقية أو اغتنم فرصة استثمارية مميزة في دبي.
                        </p>
                    ) : (
                        <>
                            <p className="px-2 my-1">
                                Discover a masterpiece of modern luxury in the heart of Motor City. These twin towers offer elegantly designed apartments with breathtaking views, world-class amenities, and a flexible payment plan. Experience sophisticated living or seize a prime investment opportunity in Dubai.
                            </p>
                        </>
                    )
                }
            </div>

            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <ApoelezzLeadForm
                    developer="Tiger"
                    project="Ananda"
                    leadType="Apartment"
                    language={currentLang?.name}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                />
                {/* <LeadForm
                    developer="Azizi"
                    project="Venice"
                    leadType="Apartment"
                    language={currentLang?.name}
                    client={true}
                    clientId={clientId}
                    clientEmail={clientMail}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Retail"]}
                /> */}
            </div>
            <Footer />
        </>
    );
}

export default TigerAnandaApoelezz;
